import { IMeta, IPagination, ISort } from "@delanobgt/admin-core/util/types";
import { produce } from "immer";
import { Reducer } from "redux";
import {
  EIdentificationSortField,
  IIdentification,
  PIdentificationFilter,
} from "src/core/identification/entities";
import { ActionType, createAction, getType } from "typesafe-actions";

/*
 * state
 */
export interface IIdentificationState {
  identifications: IIdentification[];
  loading: boolean;
  error: any;
  meta: IMeta;
}

const initialState: IIdentificationState = {
  identifications: [],
  loading: false,
  error: null,
  meta: {
    limit: 10,
    offset: 0,
    total: 0,
  },
};

/*
 * action types
 */
const FETCH_REQUESTED = "identification/FETCH_REQUESTED";
const FETCH_SUCCEEDED = "identification/FETCH_SUCCEEDED";
const FETCH_FAILED = "identification/FETCH_FAILED";
const POLLING_START_REQUESTED = "identification/POLLING_START_REQUESTED";
const POLLING_STOP_REQUESTED = "identification/POLLING_STOP_REQUESTED";

/*
 * action creators
 */
export const actions = {
  fetchRequested: createAction(FETCH_REQUESTED)(),

  fetchSucceeded: createAction(FETCH_SUCCEEDED)<{
    data: IIdentification[];
    meta: IMeta;
  }>(),

  fetchFailed: createAction(FETCH_FAILED)<any>(),

  pollingStartRequested: createAction(POLLING_START_REQUESTED)<{
    filter: PIdentificationFilter;
    pagination: IPagination;
    sorts: ISort<EIdentificationSortField>[];
    refreshDelay: number;
  }>(),

  pollingStopRequested: createAction(POLLING_STOP_REQUESTED)(),
};
export type TActions = ActionType<typeof actions>;

const reducer: Reducer<IIdentificationState, TActions> = (
  state = initialState,
  action
) => {
  return produce<IIdentificationState>(state, (draft) => {
    switch (action.type) {
      case getType(actions.fetchRequested): {
        draft.loading = true;
        draft.error = null;
        break;
      }
      case getType(actions.fetchSucceeded): {
        const {
          payload: { data, meta },
        } = action;
        draft.identifications = data;
        draft.loading = false;
        draft.error = null;
        draft.meta = meta;
        break;
      }
      case getType(actions.fetchFailed): {
        const { payload } = action;
        draft.loading = false;
        draft.error = payload;
        break;
      }
    }
  });
};

export default reducer;
